import { zetApi } from '@zet/network'

export async function fetchfilterFields(leadsType: string) {
  const response = await zetApi.get('leads/filters', {
    params: {
      ...(leadsType ? { type: leadsType } : {}),
    },
  })

  return response?.data?.data?.filters
}
